import { Input, Typography } from '@material-tailwind/react'
import React from 'react'
import Infosvg from '../../svgs/Infosvg'
import { Controller } from 'react-hook-form'
import { useDarkMode } from '../../../../rdxsga/hooks/common/useDarkMode'
import ErrorMessage from './ErrorMessage'
import Label from './Label'
import moment from 'moment'

const ControllerWithDateTime = ({ name, control, wrapperClass = "", label, required = false, placeholder, min, max }) => {
    const darkMode = useDarkMode();


    return (
        <Controller
            name={name}
            control={control}
            defaultValue=""
            render={({ field: { name, onChange, onBlur, ref, value }, fieldState }) => (
                <div className={`w-full ${wrapperClass}`}>
                    <Label darkMode={darkMode} label={label} name={name} required={required} err={!!fieldState.error} />
                    <input type='datetime-local'
                        id={name}
                        name={name}
                        onChange={e => onChange(e.target.value)}
                        onBlur={onBlur}
                        ref={ref}
                        value={value}
                        max={max}
                        min={min}
                        className={`${darkMode ? "bg-boxdark text-white" : "bg-white text-black"} shadow appearance-none border rounded w-full py-2 px-3  leading-tight border-theme focus:outline-none focus:shadow-outline`}
                    />
                    {/* <Input
                        {...field}
                        type='date'
                        // variant='standard'
                        color={darkMode ? "white" : "black"}
                        min={min}
                        max={max}
                        label={required ? `${label} *` : label}
                        className={`w-full text-blackbox placeholder:text-[#0000] focus:placeholder:text-[#0004] ${darkMode && 'text-white focus:placeholder:text-[#fff4]'}`}
                        placeholder={placeholder ?? label}
                        error={!!fieldState.error}
                    /> */}
                    <ErrorMessage fieldState={fieldState} />
                </div>
            )}
        />
    )
}

export default ControllerWithDateTime